import { resolveActivePlanKey } from './accountPresentation';

export function hasPromptBatchAccess(authState) {
  const user = authState?.user ?? null;
  const planKey = resolveActivePlanKey({ user });
  const creditsExtra = Number(
    authState?.credits?.extra ?? user?.creditsExtra ?? 0,
  ) || 0;

  return (
    planKey === 'PREMIUM'
    || planKey === 'ULTRA'
    || creditsExtra > 0
  );
}
